import { useEffect, useRef } from 'react';
import {
  Card,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import MessageFormat from './MessageFormat';

const useStyles = makeStyles((theme) => ({
  chatCard: {
    background: theme.palette.background.card,
    borderRadius: '8px',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90%',
    height: '450px',
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.background.primary,
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.background.secondary,
      borderRadius: '10px',
    },
  },
  backButton: {
    color: theme.palette.text.default,
    borderColor: theme.palette.text.default,
    marginTop: '39px',
    marginLeft: '5%',
    fontSize: '12px',
  },
  title: {
    color: theme.palette.text.default,
    textAlign: 'center',
    marginTop: '10px',
    marginBottom: '10px',
    fontSize: '20px',
    fontFamily: 'Raleway',
  },
  writeandSendMessageForm: {
    width: '90%',
    display: 'flex',
    height: '8%',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  input: {
    background: theme.palette.background.card,
    borderRadius: '8px',
    marginTop: '12px',
    marginBottom: '8px',
    width: '80%',
    color: theme.palette.text.default,
    '& ::placeholder': {
      fontStyle: 'italic',
      size: '14px',
    },
  },
  sendMessageButton: {
    color: theme.palette.text.default,
    backgroundColor: theme.palette.background.secondary,
    borderRadius: '8px',
    marginTop: '12px',
    marginBottom: '8px',
    marginLeft: '1%',
    width: '19%',
    paddingLeft: '18px',
    paddingRight: '18px',
    '&:hover': {
      background: theme.palette.background.secondary,
    },
  },
  chatEnded: {
    color: theme.palette.common.gray,
    textAlign: 'Center',
    fontSize: '15px',
    marginBottom: '5px',
  },
  writing: {
    background: theme.palette.primary.light,
    color: theme.palette.text.default,
    borderRadius: '8px',
    marginRight: 'auto',
    marginLeft: '24px',
    marginTop: '400px',
    width: 'max-content',
    maxWidth: '50%',
    padding: '7px',
  },
  messageText: {
    fontSize: '11.5px',
    fontFamily: 'Raleway',
  },
}));

function CardChat({ messages, aux, chatStatus }) {
  const classes = useStyles();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behaviour: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [aux]);

  return (
    <Card
      className={classes.chatCard}
      style={{
        maxHeight: 450,
        overflow: 'auto',
      }}
    >
      {messages.length > 0 ? (
        messages.map((message) => (
          <MessageFormat message={message} key={message.id} />
        ))
      ) : (
        <Card className={classes.writing}>
          <Typography className={classes.messageText}>
            Escribiendo...
          </Typography>
        </Card>
      )}
      {chatStatus === 'ended' ? (
        <Typography className={classes.chatEnded}>
          --- El chat ha finalizado ---
        </Typography>
      ) : null}
      <div ref={messagesEndRef} />
    </Card>
  );
}

CardChat.propTypes = {
  messages: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.string),
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  aux: PropTypes.bool.isRequired,
  chatStatus: PropTypes.string.isRequired,
};

export default CardChat;
